import { AppsAdapter } from './apps.adapter'
import {
  OneTrust,
  OneTrustApiWrapper,
} from './one-trust-api/onetrust-api.wrapper'
import { Logger } from '../utils/logging/logger'

export class ConsentProviderAdapter {
  constructor(
    private readonly apps: AppsAdapter,
    private readonly oneTrustApiWrapper: OneTrustApiWrapper,
    private readonly log: Logger
  ) {}

  private get oneTrustPromise(): Promise<OneTrust | void> {
    return this.oneTrustApiWrapper
      .getOneTrustPromise()
      .catch((error) => this.log.error(error))
  }

  async togglePreferenceCenter(): Promise<void> {
    if (this.isAppContext()) {
      this.apps.openPreferenceCenter()
    } else {
      const oneTrust = await this.oneTrustPromise
      oneTrust?.ToggleInfoDisplay()
    }
  }

  async showVendorsList(): Promise<void> {
    if (this.isAppContext()) {
      this.apps.openPreferenceCenter()
    } else {
      const oneTrust = await this.oneTrustPromise
      oneTrust?.showVendorsList()
    }
  }

  async resurfaceBanner(): Promise<void> {
    if (this.isAppContext()) {
      this.apps.resurfaceBanner()
    } else {
      await this.togglePreferenceCenter()
    }
  }

  async rejectGeneralVendorConsent(generalVendorId: string): Promise<void> {
    if (this.isAppContext()) {
      this.apps.optOutGeneralVendor(generalVendorId)
    } else {
      const oneTrust = await this.oneTrustPromise
      oneTrust?.UpdateConsent('General Vendor', `${generalVendorId}:0`)
    }
  }

  async rejectAll(): Promise<void> {
    if (this.isAppContext()) {
      this.apps.optOutAll()
    } else {
      const oneTrust = await this.oneTrustPromise
      oneTrust?.RejectAll()
    }
  }

  async allowAll() {
    if (this.isAppContext()) {
      throw new Error('allowAll not supported in app context')
    } else {
      const oneTrust = await this.oneTrustPromise
      oneTrust?.AllowAll()
    }
  }

  private isAppContext(): boolean {
    return this.apps.runningInApp()
  }
}
